import React, { useState } from 'react';
import { Button } from 'antd';
import { gql, useMutation } from '@common/hooks';
import { createMessage } from 'works/legacy/lib/message-helper';
import { Modal, PrimaryButton } from '@common/components';
import { Colors } from '@common/tokens';

export type Props = {
  changeRequestId: string;
};

const RETRACT_CHANGE_REQUEST = gql`
  mutation RetractChangeRequest($changeRequestId: String!) {
    retractChangeRequest(changeRequestId: $changeRequestId) {
      success
    }
  }
`;

type RetractChangeRequestResponse = {
  retractChangeRequest: {
    success: boolean;
  };
};

type RetractChangeRequestVariables = {
  changeRequestId: string;
};

export function RetractChangeRequest({ changeRequestId }: Props) {
  const [modalVisible, setModalVisible] = useState(false);

  const [retractChangeRequest, { loading }] = useMutation<
    RetractChangeRequestResponse,
    RetractChangeRequestVariables
  >(RETRACT_CHANGE_REQUEST, {
    variables: { changeRequestId },
    onCompleted: (data) => {
      if (data?.retractChangeRequest?.success) {
        createMessage('success', 'Change request was successfully retracted.');
      } else {
        createMessage(
          'error',
          'There was an error retracting the change request.'
        );
      }
    },
    refetchQueries: [
      'supplierDetailedCandidateProfile',
      'CandidateAssignmentQuery',
      'OfferConfirmationQuery',
    ],
  });

  const onCancelModal = () => {
    setModalVisible(false);
  };

  const onConfirmModal = () => {
    retractChangeRequest().then(() => setModalVisible(false));
  };

  return (
    <>
      <Modal
        title="Are you sure you want to retract your change request?"
        visible={modalVisible}
        confirmLoading={loading}
        onOk={onConfirmModal}
        onCancel={onCancelModal}
        footer={
          <>
            <Button key="back" onClick={onCancelModal}>
              Cancel
            </Button>
            <PrimaryButton
              key="submit"
              onClick={onConfirmModal}
              loading={loading}
            >
              Confirm
            </PrimaryButton>
          </>
        }
      >
        <p className="retract-change-request__content">
          This will return this offer to the previous state, and then you can
          accept or reject it. You can request changes again if you need to.
        </p>
      </Modal>
      <Button danger loading={loading} onClick={() => setModalVisible(true)}>
        Retract Change Request
      </Button>
      <style jsx>{`
        .retract-change-request__content {
          color: ${Colors.midnightLighter};
        }
      `}</style>
    </>
  );
}
